export const getOutlineColor = (disabled: boolean | undefined) =>
  disabled ? '#CCCCD1' : '#080812';
